import { NoticeModal, Text } from '@lili/lili-frontend-common';
import { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
import { errorModalState } from './errorModalState';
import { ReactComponent as OopsIcon } from '@/assets/svg/icons/oops.svg';

export const ErrorModal = () => {
  const { t } = useTranslation();
  const { isOpen, message } = useSyncExternalStore(
    errorModalState.subscribe,
    errorModalState.getSnapshot
  );

  if (!isOpen) return null;

  const content = (
    <div className='flex justify-center items-center mb-[48px] gap-1'>
      <Text.H10>{message ?? t('errorModal.description')}</Text.H10>
    </div>
  );

  return (
    <NoticeModal
      id='error-modal'
      image={<OopsIcon />}
      title={t('errorModal.title')}
      content={content}
      buttonText={t('errorModal.button')}
      onSubmit={errorModalState.hide}
      onClickOutside={errorModalState.hide}
    />
  );
};
